import { render, staticRenderFns } from "./UserOtherInterestTable.vue?vue&type=template&id=0b1366fa&"
import script from "./UserOtherInterestTable.vue?vue&type=script&lang=js&"
export * from "./UserOtherInterestTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports